<div role="dialog" aria-modal="true" aria-labelledby="z-ticket-title"
  class="flex flex-col bg-white rounded-[14px] p-[30px] gap-[20px] h-[90vh]">
  <h2 id="z-ticket-title" class="text-[20px] font-semibold fg-noir-2 text-center leading-none">
    {{ 'z_ticket.modal_title' | translate }}
  </h2>

  <!-- Ticket Z tel que mis en page par le back -->
  @if (pdfUrl(); as url) {
  <iframe class="flex-1 min-h-0 w-full rounded-[10px] border border-gris-3" [src]="url"
    [title]="'z_ticket.modal_title' | translate"></iframe>
  }

  <div class="flex gap-[10px]">
    <button type="button" (click)="closeClick.emit()"
      class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex-1 flex items-center justify-center fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors">
      {{ 'common.close' | translate }}
    </button>
    <button type="button" (click)="downloadClick.emit()"
      class="rounded-[5px] h-[58px] px-5 flex-1 flex items-center justify-center bg-vert-1 text-white text-[16px] font-semibold cursor-pointer hover:opacity-90 transition-opacity">
      {{ 'z_ticket.download' | translate }}
    </button>
  </div>
</div>
